import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const headTable = () => {
  return [
    {
      no: 'No.',
      name: 'Nama',
      amount: 'Jumlah',
      description: 'Deskripsi',
    },
  ];
};

const DebtReportPDF = (data, year, employeeName) => {
  let doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: 'portrait',
    format: [210, 330],
  });

  let result =
    data?.data?.map((x, i) => ({
      no: `${i + 1}.`,
      name: x.employee?.name || '',
      amount: `Rp. ${x.amount?.toLocaleString('id-ID')}`,
      description: x.description || '-',
    })) || [];

  const grand_total = Number(data?.total ?? 0);

  if (!result.length) {
    result = [
      [
        {
          content: 'Tidak ada data',
          colSpan: 4,
          styles: { halign: 'center', valign: 'middle', fontStyle: 'bold' },
        },
      ],
    ];
  }

  const gt = [
    [
      {
        content: 'Total',
        colSpan: 3,
        styles: { halign: 'center', valign: 'middle', fontStyle: 'bold' },
      },
      {
        content: `Rp. ${grand_total?.toLocaleString('id-ID')}`,
        styles: { fontStyle: 'bold' },
      },
    ],
  ];

  doc.setFontSize(10);
  doc.setFont('times', 'bold');
  doc.text('Laporan Total Hutang Pribadi', 14, 10);
  doc.text(`Tahun ${year}`, 14, 15);
  doc.text(`Nama Marketing: ${employeeName}`, 14, 20);

  autoTable(doc, {
    startY: 23,
    theme: 'grid',
    headStyles: { fillColor: [47, 84, 150], textColor: 'white' },
    head: headTable(),
    body: [...result, ...gt],
    columnWidth: 'wrap',
    tableWidth: 'auto',
    styles: {
      overflow: 'linebreak',
      overflowColumns: 'linebreak',
      textColor: 'black',
    },
  });

  doc.setProperties({
    title: 'Laporan Hutang Pribadi',
  });

  window.open(
    doc.output('bloburl', {
      filename: 'Laporan Hutang Pribadi.pdf',
    }),
  );
};

export default DebtReportPDF;
